/*
 * File: store.ts
 * Project: receiving-rules
 * -----
 * Last Modified: 30 Sep 2020 4:54:42 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { AnyAction, configureStore, ThunkDispatch } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { appApi } from 'redux/services/useAbbyCadabbyService';
import { buyerApi, customerApi } from 'redux/services/useBeautifylDayMonsterService';
import { deliveryApi } from 'redux/services/useGladysTheCowService';
import { salesOrderTypesApi } from 'redux/services/useGrannyFannyNesselrodeService';
import { warehouseSiteApi } from 'redux/services/useKingstonLivingstonService';
import { salespersonApi } from 'redux/services/useLeftyTheSalesmanService';
import { salesOrderApi } from 'redux/services/useMamaBearService';
import { rtkQueryErrorLogger } from './apiResponseMiddleware';
import rootReducer, { ReduxState } from './rootReducer';
import { ocdApi } from './services/useAnimalService';
import { deliveryAddressApi } from './services/useBusterTheHorseService';
import { worldsApi } from './services/useChuckieSueService';
import { userApi } from './services/useCookieMonster';
import { productsApi } from './services/useDonaldGrumpService';
import { floBearApi } from './services/useFloBearApi';
import { applicationApi } from './services/useFreddyCadabbyServices';
import { legalEntitiesApi } from './services/useMaggieCadabbyService';
import { vendorsApi } from './services/useSimonSoundman';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(rtkQueryErrorLogger)
      .concat(appApi.middleware)
      .concat(productsApi.middleware)
      .concat(ocdApi.middleware)
      .concat(customerApi.middleware)
      .concat(buyerApi.middleware)
      .concat(deliveryApi.middleware)
      .concat(salesOrderApi.middleware)
      .concat(salesOrderTypesApi.middleware)
      .concat(salespersonApi.middleware)
      .concat(warehouseSiteApi.middleware)
      .concat(deliveryAddressApi.middleware)
      .concat(vendorsApi.middleware)
      .concat(worldsApi.middleware)
      .concat(userApi.middleware)
      .concat(applicationApi.middleware)
      .concat(legalEntitiesApi.middleware)
      .concat(floBearApi.middleware)
});

// if (process.env.NODE_ENV === 'development' && module.hot) {
//   module.hot.accept('./rootReducer', () => {
//     // eslint-disable-next-line @typescript-eslint/no-var-requires
//     const newRootReducer = require('./rootReducer').default;

//     store.replaceReducer(newRootReducer);
//   });
// }

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type ThunkAppDispatch = ThunkDispatch<ReduxState, void, AnyAction>;

export default store;
